import { useEffect, useRef, useState } from "react";
import { endpoint } from "./endpoint";
import { useNavigate, Link } from 'react-router-dom'; // Import Link from React Router
import "./QrStyles.css";
import Notiflix from "notiflix";
// Qr Scanner
import QrScanner from "qr-scanner";
import QrFrame from "./qr-frame.svg";

const QrReader = () => {
  // QR States
  const scanner = useRef();
  const videoEl = useRef(null);
  const qrBoxEl = useRef(null);
  const [qrOn, setQrOn] = useState(true);
  const navigate = useNavigate(); // Hook from React Router to navigate programmatically

  // Result
  const [scannedResult, setScannedResult] = useState("");

  const onScanSuccess = (result) => {
    setScannedResult(result?.data);
    const token = localStorage.getItem("authToken");

    fetch(
      `${endpoint}/gymapp/addbag.php?token=${encodeURIComponent(
        token
      )}&bag=${encodeURIComponent(result?.data)}`
    )
      .then((res) => res.json())
      .then((data) => {
        const result=data.status;
		if(result === "success"){
	    Notiflix.Notify.info("Bag added successfully");
		navigate("/bags");
		}else{
		Notiflix.Notify.failure("There was an error adding this bag");
		navigate("/bags");
		}
      })
      .catch((error) => {
        Notiflix.Notify.failure("Something went wrong");
		navigate("/bags");
      });
  };

  // Fail
  const onScanFail = (err) => {
    // Print the error to browser console.
    console.log(err);
  };

  useEffect(() => {
    if (videoEl?.current && !scanner.current) {
      // Instantiate the QR Scanner
      scanner.current = new QrScanner(videoEl?.current, onScanSuccess, {
        onDecodeError: onScanFail,
        preferredCamera: "environment",
        highlightScanRegion: true,
        highlightCodeOutline: true,
        overlay: qrBoxEl?.current || undefined,
      });

      // Start QR Scanner
      scanner?.current
        ?.start()
        .then(() => setQrOn(true))
        .catch((err) => {
          if (err) setQrOn(false);
        });
    }

    // Clean up on unmount.
    return () => {
      if (!videoEl?.current) {
        scanner?.current?.stop();
      }
    };
  }, []);

  // If "camera" is not allowed in browser permissions, show an alert.
  useEffect(() => {
    if (!qrOn)
      Notiflix.Report.failure("Camera Problem",
        "Camera is blocked or not accessible. Please allow camera in your browser permissions and Reload."
         ,"Ok"     
	 );
  }, [qrOn]);

  return (
    <div className="qr-reader">
      {/* QR */}
      <video ref={videoEl}></video>
      <div ref={qrBoxEl} className="qr-box">
        <img
          src={QrFrame}
          alt="Qr Frame"
          width={256}
          height={256}
          className="qr-frame"
        />
      </div>

      {/* Show Data Result if scan is success */}
      {scannedResult && (
        <div className="scanned-result">
          <h3>Scanned Bag Details</h3>
          <div className="bag-card">
            <p><strong>Bag Code:</strong> {scannedResult}</p>
            {/* Add more details about the bag here if available */}
          </div>
        </div>
      )}
    </div>
  );
};

export default QrReader;
